export const actionTypes = {
  updateCategories: "UPDATE_CAREGORIES",
};

const initialState = [];

const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.updateCategories:
      return [...action.payload];
    default:
      return state;
  }
};

export const actions = {
  updateCategories: (categories) => ({
    type: actionTypes.updateCategories,
    payload: categories
  }),
};

export default categoryReducer;
